export const fileStatus = [
  { name: 'All', value: 'All' },
  { name: 'Open', value: 'Open' },
  { name: 'Opened in Error', value: 'Opened in Error' },
  { name: 'Cancelled', value: 'Cancelled' },
  { name: 'Closed', value: 'Closed' },
];

export enum fileStatuses {
  open = 'Open',
  openedInError = 'Opened in Error',
  cancelled = 'Cancelled',
  closed = 'Closed',
  openRemitted = 'Open Remitted',
}

export const fileStatusFileInformation = [
  { name: 'Open', value: 'Open' },
  { name: 'Opened in Error', value: 'Opened in Error' },
  { name: 'Cancelled', value: 'Cancelled' },
  { name: 'Closed', value: 'Closed' },
];
export const getFileStatus = [
  { name: 'A Married Couple', value: 'A Married Couple' },
  { name: 'Individual', value: 'Individual' },
  { name: 'Entity', value: 'Entity' },
  { name: 'Trust/Estate', value: 'Trust/Estate' },
];
export const getMaritalStatus = [
  { name: 'Marital status to be determined', value: '(marital status to be determined)' },
  { name: 'Married Couple', value: 'a married couple' },
  { name: 'Married man', value: 'a married man' },
  { name: 'Married woman', value: 'a married woman' },
  { name: 'Registered Domestic Partner', value: 'a registered domestic partner' },
  { name: 'Registered Domestic Partners', value: 'as registered domestic partners' },
  { name: 'Single Man', value: 'a single man' },
  { name: 'Single Woman', value: 'a single woman' },
  { name: 'Single Person', value: 'a single person' },
  { name: 'Widow', value: 'a widow' },
  { name: 'Widower', value: 'a widower' },
  { name: 'Unmarried Man', value: 'an unmarried man' },
  { name: 'Unmarried Woman', value: 'an unmarried woman' },
  { name: 'Unmarried Person', value: 'an unmarried person' },
  { name: 'Husband and Husband', value: 'husband and husband' },
  { name: 'Husband and Wife', value: 'husband and wife' },
  { name: 'Married Spouses', value: 'married spouses' },
  { name: 'Wife and Husband', value: 'wife and husband' },
  { name: 'Wife and Wife', value: 'wife and wife' },
];
export const PropertyTypeOptions = [
  { name: 'Residential (1-4 family)', value: 'Residential (1-4 family)' },
  { name: 'Non-residential', value: 'Non-residential' },
  { name: 'Commercial', value: 'Commercial' },
];

export const EntityType = [
  { name: '', value: '' },
  { name: 'Business Trust', value: 'Business Trust' },
  { name: 'Corporation', value: 'Corporation' },
  { name: 'General Partnership', value: 'General Partnership' },
  { name: 'Joint Venture', value: 'Joint Venture' },
  { name: 'Limited Liability Company', value: 'Limited Liability Company' },
  { name: 'Limited Partnership', value: 'Limited Partnership' },
  { name: 'Non-Profit Corporation', value: 'Non-Profit Corporation' },
  { name: 'Non-Profit Public Benefit Corporation', value: 'Non-Profit Public Benefit Corporation' },
  { name: 'Other', value: 'Other' },
  { name: 'Professional Corporation', value: 'Professional Corporation' },
];
export const officeOptions = [{ name: 'Integrity Lending, Irvine CA ', value: 'integrityLending' }];
export const transactionTypes = [
  { name: 'Sale/Cash', value: 'Sale/Cash' },
  { name: 'Sale w/Mortgage', value: 'Sale w/Mortgage' },
  { name: 'Refinance', value: 'Refinance' },
  { name: 'Equity Loan', value: 'Equity Loan' },
  { name: 'Sale w/Construction Loan', value: 'Sale w/Construction Loan' },
  { name: 'Other', value: 'Other' },
];
export const searchTypes = [
  { name: 'All Files', value: 'all' },
  { name: 'File #', value: 'fileNumber' },
  { name: 'Service Order #', value: 'serviceOrderNumber' },
  { name: 'Buyer', value: 'buyer' },
  { name: 'Seller', value: 'seller' },
  { name: 'Address', value: 'address' },
  { name: 'Lender', value: 'lender' },
  { name: 'Underwriter', value: 'underwriter' },
  { name: 'Transaction Type', value: 'transactionType' },
];
export const dateRangeTypes = [
  { name: 'Last 30 Days', value: '1' },
  { name: 'Last 3 Months', value: '3' },
  { name: 'Last 6 Months', value: '6' },
  { name: 'Last 1 Year', value: '12' },
  { name: 'Custom Range', value: 'custom' },
];
export const dateRangeFilters = {
  equal: 'Equal',
  greaterThan: 'Greater Than',
  lessThan: 'Less Than',
  inRange: 'In Range',
};
export const STATE_CODES = {
  CT: 'CT',
  KY: 'KY',
};
export const PREMIUM_TAX_CODES = {
  UNDETERMINED_KY: '000',
};
export const Notice = `Name(s) to Search (IMPORTANT NOTICE: This ad hoc SDN search page is provided as an accommodation.
  However, the search results will not be retained in AgentNet.
  For open title orders, use the SDN tab where AgentNet provides default SDN searches for the buyers, sellers and lenders and retains the result in the file.
  For information on (i) searching mandates, and (ii) clearing and documenting possible "hits", please review the applicable underwriting bulletins in the Underwriting Library,
  contact your counsel or visit the federal SDN site at: <a href="http://www.treasury.gov/sdn" target="_blank" class="linkBtn">www.treasury.gov/sdn</a>)`;

export const PolicyNotice = `The Policy Upload tool in AgentNet® is only to upload policy schedules and endorsements which have already been reported or are in the process of being reported. Submitting policies on the upload tool does not send them to accounting for remittance purposes. Generally policies are available in the Back Title database within 2 weeks.`;

export const Content = `Disclaimer: The starter image in the Back Title Database is provided to you solely in your capacity as a
  policy issuing agent of First American and is subject to the terms and conditions of the AgentNet End User License Agreement, the terms and conditions of your current First American policy-issuing agency agreement, as well as all relevant First American National and local underwriting communications and guidance.`;

export const docType = [
  { name: 'All', value: 'All' },
  { name: 'Legal Description', value: 'Legal Description' },
  { name: 'Starter', value: 'Starter' },
  { name: 'Prior Loan Policy', value: 'Prior Loan Policy' },
  { name: 'Prior Owner Policy', value: 'Prior Owner Policy' },
];

export const StartnewBTSearch =
  'We could not find any documents associated with the address on this file. Would you like to start a new search?';

export const OFACPdfWindowName = 'OFAC PDF';
export const SdnPdfWindowName = 'OFAC PDF';
export const BackTitlePdfWindowName = 'BackTitle PDF';
export const newWindow = '_blank';
export const WindowFeatures = 'popup';
export const Regex = `^[A-Za-z0-9-' ]+$`;
export const RegexAlphanumeric = `^[A-Za-z0-9 ]+$`;
export const RegexNumeric = /^[0-9 ]+$/;
export const SdnErrorAlert = 'Unable to return search results';
export const SdnWarningAlert = 'Search name is required';
export const SdnAlertDuration = 6000;
export const DateFormat = 'MM/DD/YYYY';
export const DocumentType = 'application/pdf;base64';
export const zipDocType = 'application/zip';
export const excelDocType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const wordDocType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const xmlDocType = 'application/xml';
export const htmlDocType = 'text/html';
export const txtDocType = 'text/plain';
export const xlsDocType = 'application/vnd.ms-excel';
export const msgDocType = 'application/vnd.ms-outlook';
export const jsonDocType = 'application/json';
export const fpxDocType = 'application/fpx';
export const pxtDocType = 'application/pxt';
export const addRowsMaxCount = 3;
export const SdnRegex = /[a-zA-Z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
export enum httpErrorCodes {
  badRequest = '400',
  notFound = '404',
  forbidden = '403',
  internalServerError = '500',
}

export const policyUploadStatus = [
  { name: 'All', value: 'All' },
  { name: 'Uploaded', value: 'Uploaded' },
  { name: 'In process', value: 'In process' },
  { name: 'Available in production', value: 'Available in production' },
  { name: 'Invalid File Type', value: 'Invalid File Type' },
  { name: 'Server Error', value: 'Server Error' },
  { name: 'Password Proteced Document', value: 'Password Proteced Document' },
  {
    name: 'Invalid File Type or Password Protected Document',
    value: 'Invalid File Type or Password Protected Document',
  },
];
export const residentialPropertyTypes = ['Default-Residential', 'New Home', 'Residential', 'Subdivision', 'Time Share'];
export const nonResidentialPropertyTypes = ['Commercial', 'Default-Commercial', 'Time Share'];
export const contactUsReasons = [
  { name: 'Add User', value: 'Add User' },
  { name: 'Agent Activity Rights', value: 'Agent Activity Rights' },
  { name: 'AVL', value: 'AVL' },
  { name: 'Back Title', value: 'Back Title' },
  { name: 'Closing Protection Letters', value: 'Closing Protection Letters' },
  { name: 'Disable User', value: 'Disable User' },
  { name: 'Documents', value: 'Documents' },
  { name: 'ePay', value: 'ePay' },
  { name: 'Invoices/Statements', value: 'Invoices/Statements' },
  { name: 'Jackets', value: 'Jackets' },
  { name: 'Login Issue', value: 'Login Issue' },
  { name: 'My Files', value: 'My Files' },
  { name: 'Policy Upload', value: 'Policy Upload' },
  { name: 'Rates & Fees', value: 'Rates & Fees' },
  { name: 'Remittance', value: 'Remittance' },
  { name: 'Reports', value: 'Reports' },
  { name: 'SDN', value: 'SDN' },
  { name: 'Service Order (BOPS)', value: 'Service Order (BOPS)' },
  { name: 'Signatory', value: 'Signatory' },
  { name: 'Third Party Integration', value: 'Third Party Integration' },
  { name: 'Update Profile', value: 'Update Profile' },
  { name: 'Other', value: 'Other' },
];

export const frequency = [
  { name: 'Daily', value: 'Daily' },
  { name: 'Weekly', value: 'Weekly' },
  { name: 'Bi-Monthly (15th & 25th)', value: 'Bi-Monthly (15th & 25th)' },
  { name: 'Monthly (25th)', value: 'Monthly (25th)' },
];

export const daysAfterPolicyDate = [
  { name: '5', value: '5' },
  { name: '15', value: '15' },
  { name: '30', value: '30' },
  { name: '45', value: '45' },
  { name: '60', value: '60' },
];

export const reportDays = [
  { name: 'Monday', value: 'Monday' },
  { name: 'Tuesday', value: 'Tuesday' },
  { name: 'Wednesday', value: 'Wednesday' },
  { name: 'Thursday', value: 'Thursday' },
  { name: 'Friday', value: 'Friday' },
];

export const DeleteEsignature = {
  DELETE_ESIG_CONFIRM_MSG: `You are about to permanently delete this eSignature. Are you sure want to Proceed?`,
};

export const userType = ['Agent', 'Staff'];
export const hqUser = ['Yes', 'No'];
export const userStatus = ['Inactive', 'Not Activated', 'Active', 'Disabled'];
export const firmStatus = ['Active', 'Inactive'];

// Account/Office/Firm status constants (lowercase for comparison with .toLowerCase())
export const ACTIVE_STATUS = 'active';
export const userRoleAgent = ['Agent', 'Title & Escrow User', 'Escrow Only User', 'CPL Only', 'Title Only User'];
export const userRoleStaff = ['User', 'Staff Administrator', 'System Administrator', 'On Behalf Of', 'FSC OM'];

export const KBLinks = {
  home: 'https://agentnet.firstam.com/help',
  filesList: 'https://agentnet.firstam.com/help/file-basics/all-files-dashboard',
  fileInfo: 'https://agentnet.firstam.com/help/file-basics',
  cpl: 'https://agentnet.firstam.com/help/file-products-and-services/closing-protection-letters-cpls',
  policyUpload: 'https://agentnet.firstam.com/help/non-file-services/policy-upload',
  sdn: 'https://agentnet.firstam.com/help/non-file-services/specially-designated-nationals-sdn-search',
  backtitleAdHoc: 'https://agentnet.firstam.com/help/non-file-services/back-title-search',
  backtitleFiles: 'https://agentnet.firstam.com/help/file-products-and-services/back-title-search-in-a-file',
  avl: 'https://agentnet.firstam.com/help/non-file-services/agency-verification-letters-avls',
  serviceOrderFiles:
    'https://agentnet.firstam.com/help/file-products-and-services/service-orders-title-search-products',
  orderInsights: 'https://agentnet.firstam.com/help/file-products-and-services/order-insights',
  billing: 'https://agentnet.firstam.com/help/accounting/epay-payment-accounts',
  eSignatures: 'https://agentnet.firstam.com/help/admin-settings/manage-e-signatures',
  autoReporting: 'https://agentnet.firstam.com/help/admin-settings/auto-reporting-policy-premium-set-up',
  addressBook: 'https://agentnet.firstam.com/help/admin-settings/manage-address-book',
  serviceOrderInvoicePay: 'https://agentnet.firstam.com/help/accounting/pay-service-order-invoices',
  prefferedOffice: 'https://agentnet.firstam.com/help/admin-settings/manage-user-profile-and-preferred-offices',
  reports: 'https://agentnet.firstam.com/help/reports',
  underwritingRequest: 'https://agentnet.firstam.com/help/file-products-and-services/underwriting-request',
  jacketsCreate: 'https://agentnet.firstam.com/help/file-products-and-services/jackets',
  reportPayPay: 'https://agentnet.firstam.com/help/accounting/report-remit-files', //keep report links separate for future changes
  reportPayReview: 'https://agentnet.firstam.com/help/accounting/report-remit-files', //keep report links separate for future changes
  reportPayReport: 'https://agentnet.firstam.com/help/accounting/report-remit-files', //keep report links separate for future changes
  serviceOrderDashboard: 'https://agentnet.firstam.com/help/reports/service-order-dashboard',
  addOns: 'https://agentnet.firstam.com/help/admin-settings/add-ons',
  identityVerification: 'https://agentnet.firstam.com/help/non-file-services/identity-verification-services',
  wireValidation: 'https://agentnet.firstam.com/help/non-file-services/wire-validation-services',
  fincenReport:
    'https://knowledge.agentnet.firstam.com/auth/auto-signin?type=b2c&callbackUrl=/?landing-page=spotlight/fincen-resources',
};

export const wireVerificationHelpText = `Personal: Individual or joint account, Trust account (listed with the full name of the person who owns the bank account, ex: "Jane Doe," rather than "Jane Doe Family Trust.")

Business: Corporation, LLC, LTD Estate, etc.

Payoff: Bank-owned Mortgage Payoff Accounts`;

// Preferred Office notifications
export const PREFERRED_OFFICE_TOOLTIP =
  'Results are filtered based on your preferred office settings. To make changes, visit Admin > User Profile & Preferences > Preferred Offices.';

// Remittance Report tab - policy date messaging
export const POLICY_DATE_OLDER_THAN_DAYS = 90;
export const POLICY_DATE_FUTURE_TOOLTIP = 'Policy date is in the future';
export const POLICY_DATE_OLDER_90_TOOLTIP = `Policy date is older than ${POLICY_DATE_OLDER_THAN_DAYS} days`;
export const FUTURE_DATED_REPORT_CHECKBOX_TOOLTIP = 'Future-dated policies cannot be reported';

// Remittance Report/Pay tab - remittance basis indicator (formattedAmount already includes currency formatting)
export const REMITTANCE_BASIS_TOOLTIP = (formattedAmount: string): string =>
  `Remittance Basis amount of ${formattedAmount} applied`;

// Create File - default office pre-selection
export const DEFAULT_OFFICE_LABEL = '(Default Office)';

// Support contact information
export const AGENCY_SUPPORT_PHONE = '866-701-3361';
export const AGENCY_SUPPORT_MESSAGE = `If the problem continues, please call Agency Support at ${AGENCY_SUPPORT_PHONE}.`;
